import { render } from "./TheHeader.vue?vue&type=template&id=9b35fc06&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=9b35fc06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9b35fc06"

export default script